import { get, getRawValue } from '../../utils/get';
import { getKeys, hasMissingSchemaVariables } from '../../adapters/utils';
import { renderStructureData } from './structured-data/render-structured-data';
import { SD_STATUS } from '../../consts';
export var IDs = {
    NAME: 'blog-tag.name',
    PAGE_URL: 'blog-tag.fullUrl',
    POST_COUNT: 'blog-tag.postCount',
    CREATED_DATE: 'blog-tag.created.date',
    DESCRIPTION: 'blog-tag.description',
    SD_DISABLED: 'blog-tag.disable-schema',
    SD_JSON_RENDER: 'blog-tag.structured-data.render',
};
var userVisible = [IDs.NAME, IDs.POST_COUNT, IDs.PAGE_URL];
var requiredSchemaVariables = [];
var SchemaTypes = {
    BLOG_TAGS_PAGE: 'blog-tags-page-preset',
};
var getListItems = function (item) { return getRawValue(item, 'tag.listItems') || []; };
var getSdStatus = function (item) {
    if (hasMissingSchemaVariables(requiredSchemaVariables, item)) {
        return SD_STATUS.DISABLED_DUE_TO_MISSING_INFO;
    }
    if (getListItems(item).length <= 1) {
        return SD_STATUS.DISABLED_BY_VERTICAL_ITEM_DATA;
    }
    return SD_STATUS.ENABLED;
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a;
        var sdStatusEnabled = getSdStatus(item) === SD_STATUS.ENABLED;
        return _a = {},
            _a[IDs.NAME] = get(item, 'tag.name'),
            _a[IDs.PAGE_URL] = get(item, 'tag.fullUrl'),
            _a[IDs.POST_COUNT] = get(item, 'tag.postCount'),
            _a[IDs.CREATED_DATE] = get(item, 'tag.created'),
            _a[IDs.DESCRIPTION] = get(item, 'tag.description'),
            _a[IDs.SD_DISABLED] = !sdStatusEnabled,
            _a[IDs.SD_JSON_RENDER] = sdStatusEnabled
                ? renderStructureData(getListItems(item))
                : {},
            _a;
    },
    getSdStatus: getSdStatus,
    getLegacySeoBlob: function () { },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getBiData: function () { },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return []; },
};
